import { fly } from 'svelte/transition';
import { quintOut } from 'svelte/easing';

export const PANE_SLIDE = {
  x: 80,
  duration: 380,
  opacity: 1,
  easing: quintOut,
};

export function paneSlide(node, params = {}) {
  return fly(node, { ...PANE_SLIDE, ...params });
}
